var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ 'mobile-device': _vm.isMobile },attrs:{"id":"app"}},[_c('Spinner'),(!_vm.meetJoined)?_c('app-header'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }